// src/components/Navbar.js
import React, { useState } from 'react';
import { Layout, Menu, Modal, Button, Drawer, Grid } from 'antd';
import { MenuOutlined, LogoutOutlined, LoginOutlined, SearchOutlined, ApartmentOutlined, BranchesOutlined } from '@ant-design/icons';
import Login from './Login';
import BranchSelection from './BranchSelection';

const NavBar = ({ selectedBranch, onSearchToggle, onAdvancedSearchToggle, onBranchChange }) => {
    const [showLogin, setShowLogin] = useState(false);
    const [showBranchSelect, setShowBranchSelect] = useState(false);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('userToken'));

    const handleLogoutConfirm = () => {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userBranch');
        
        // Reset branch to previously selected branch if exists
        const previousBranch = localStorage.getItem('selectedBranch');
        if (previousBranch) {
            onBranchChange(JSON.parse(previousBranch));
        }
        
        setIsLoggedIn(false);
        setShowLogoutConfirm(false);
    };

    const handleLoginSuccess = (data) => {
        setIsLoggedIn(true);
        // Update branch to logged in user's branch
        if (data.branch) {
            const branchData = {
                id: data.branch.id,
                branch: data.branch.branch
            };
            localStorage.setItem('selectedBranch', JSON.stringify(branchData));
            localStorage.setItem('userBranch', JSON.stringify(branchData));
            onBranchChange(branchData);
        }
        setShowLogin(false);
    };

    const handleBranchChange = (branch) => {
        // Only allow branch change if user is not logged in
        if (!isLoggedIn) {
            const branchData = {
                id: branch.id,
                branch: branch.branch
            };
            onBranchChange(branchData);
            localStorage.setItem('selectedBranch', JSON.stringify(branchData));
            setShowBranchSelect(false);
        } else {
            alert("You cannot change branch while logged in. Your branch is set to your login branch.");
        }
    };

    const [drawerOpen, setDrawerOpen] = useState(false);
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    const menuItems = [
        {
            key: 'basic-search',
            icon: <SearchOutlined style={{ color: '#262626' }} />, // dark icon
            label: 'Basic Search',
            style: { marginRight: 10, background: '#fff', borderRadius: 5, height: 35, display: 'flex', alignItems: 'center', fontWeight: 'normal', fontSize: '12px', color: '#262626', border: '1px solid #1890ff', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' },
            onClick: onSearchToggle
        },
        {
            key: 'advanced-search',
            icon: <ApartmentOutlined style={{ color: '#262626' }} />, // dark icon
            label: 'Advanced Search',
            style: { marginRight: 10, background: '#fff', borderRadius: 5, height: 35, display: 'flex', alignItems: 'center', fontWeight: 'normal', fontSize: '12px', color: '#262626', border: '1px solid #52c41a', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' },
            onClick: onAdvancedSearchToggle
        },
        {
            key: 'branch',
            icon: <BranchesOutlined style={{ color: '#262626' }} />, // dark icon
            label: `Branch: ${selectedBranch.branch}`,
            style: { marginRight: 10, background: '#e6f7ff', borderRadius: 5, height: 35, display: 'flex', alignItems: 'center', fontWeight: 'normal', fontSize: '12px', color: '#0050b3', border: '1px solid #1890ff', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' },
            onClick: () => !isLoggedIn && setShowBranchSelect(true)
        },
        isLoggedIn
            ? {
                key: 'logout',
                icon: <LogoutOutlined style={{ color: '#fff' }} />, // white icon
                label: 'Logout',
                style: { marginRight: 10, background: '#f5222d', borderRadius: 5, height: 35, display: 'flex', alignItems: 'center', fontWeight: 'normal', fontSize: '12px', color: '#fff', border: '1px solid #cf1322', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' },
                onClick: () => setShowLogoutConfirm(true)
            }
            : {
                key: 'login',
                icon: <LoginOutlined style={{ color: '#fff' }} />, // white icon
                label: 'Login',
                style: { marginRight: 10, background: '#1890ff', borderRadius: 5, height:   35, display: 'flex', alignItems: 'center', fontWeight: 'normal', fontSize: '12px', color: '#fff', border: '1px solid #0050b3', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' },
                onClick: () => setShowLogin(true)
            }
    ];

    return (
        <>
            <Layout.Header style={{ background: '#001529', display: 'flex', alignItems: 'center', padding: isMobile ? '0 8px' : '0 24px', height: 60 }}>
                <div style={{ display: 'flex', alignItems: 'center', backgroundColor: 'white', borderRadius:'10px',padding:'5px 10px', marginRight: 18 }}>
                    <img src="/logo.png" alt="Logo" style={{ height: '25px', width: 'auto' }} />
                </div>
                {isMobile ? (
                    <>
                        <Button type="text" icon={<MenuOutlined style={{ fontSize: 28, color: '#fff' }} />} onClick={() => setDrawerOpen(true)} style={{ marginLeft: 'auto' }} />
                        <Drawer
                            title={<div style={{display:'flex',alignItems:'center'}}><img src="/logo.png" alt="Logo" style={{ height: 32, marginRight: 8 }} /> Menu</div>}
                            placement="right"
                            onClose={() => setDrawerOpen(false)}
                            open={drawerOpen}
                            bodyStyle={{ padding: 0 }}
                        >
                            <Menu
                                mode="vertical"
                                theme="light"
                                style={{ borderRight: 'none', fontSize: 16, fontWeight: 500 }}
                                items={menuItems}
                                selectable={false}
                            />
                        </Drawer>
                    </>
                ) : (
                    <Menu
                        mode="horizontal"
                        theme="light"
                        style={{ background: 'transparent', border: 'none', fontSize: 16, fontWeight: 600, flex: 1 }}
                        items={menuItems}
                        selectable={false}
                    />
                )}
            </Layout.Header>

            {/* Login Modal */}
            <Login 
                show={showLogin}
                onHide={() => setShowLogin(false)}
                onLogin={handleLoginSuccess}
            />

            {/* Branch Selection Modal */}
            <BranchSelection 
                show={showBranchSelect}
                onHide={() => setShowBranchSelect(false)}
                onSelectBranch={handleBranchChange}
                initialBranch={selectedBranch}
            />

            {/* Logout Confirmation Modal */}
            <Modal
                open={showLogoutConfirm}
                onCancel={() => setShowLogoutConfirm(false)}
                footer={null}
                title="Confirm Logout"
                centered
                destroyOnClose
            >
                <div style={{ marginBottom: 24 }}>Are you sure you want to logout?</div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button onClick={() => setShowLogoutConfirm(false)}>
                        Cancel
                    </Button>
                    <Button type="primary" danger onClick={handleLogoutConfirm}>
                        Logout
                    </Button>
                </div>
            </Modal>
            
        </>
    );
}

export default NavBar;
